import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    user : {},
    isLogin : false
}

const userSlice = createSlice({
    name : 'user',
    initialState,
    reducers : {
        login : (state, action) => {
            state.user = action.payload
            state.isLogin = true
        },
        logout : (state) => {
            state.user = {}
            state.isLogin = false
        }
    }
})

export const  {login, logout } = userSlice.actions
export const stateUser = (state) => state.user
export default userSlice.reducer